import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const InvitePeopleIcon = (props: IconProps) => (
  <Icon width="75px" height="30px" viewBox="0 0 75 30" {...props}>
    <mask
      id="mask0_4597_27940"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="8"
      width="21"
      height="22"
    >
      <circle cx="10.5" cy="19" r="10.5" fill="#B94C24" />
    </mask>
    <g mask="url(#mask0_4597_27940)">
      <rect
        x="-3.35999"
        y="4.50977"
        width="41.58"
        height="39.69"
        fill="#73D9F0"
      />
      <path
        d="M9.62072 28.2045C7.14146 28.3581 3.93806 27.5399 2.33905 32.2285C1.11423 40.6836 -0.982788 73.307 -0.982788 73.307L22.7116 73.4836C22.7116 73.4836 21.7384 44.7629 18.7733 32.2231C17.9563 28.768 16.1096 29.7952 15.1526 29.0537C13.5631 28.3837 11.7312 28.0723 9.62341 28.2031L9.62072 28.2045Z"
        fill="#1D9AD2"
      />
      <path
        d="M6.23023 35.4464C6.23023 35.4464 -0.268092 32.3364 1.87603 27.7031C4.02015 23.0697 20.5661 24.9099 20.4638 29.0026C20.3615 33.094 12.3961 35.9937 12.3961 35.9937L6.23157 35.4464H6.23023Z"
        fill="#1D9AD2"
      />
      <path
        d="M5.57345 20.5908C5.57345 20.5908 4.67703 17.5738 5.44827 15.5611C6.42006 13.0294 11.0461 10.2146 12.563 10.9197C14.0813 11.6247 11.8403 13.2397 12.5307 13.4406C13.2212 13.6414 13.6398 12.0345 14.1015 12.3324C15.967 13.5363 14.7597 19.8749 14.7597 19.8749L8.2573 17.9243L5.57345 20.5908Z"
        fill="#5B5B5B"
      />
      <path
        d="M12.7757 29.0474L10.5455 31.1719L8.31384 29.0474L8.70552 24.2334H12.384L12.7757 29.0474Z"
        fill="#F9C1AD"
      />
      <path
        d="M14.2455 18.5027C13.9911 16.2218 11.987 14.9344 9.71631 15.1878C7.44702 15.4413 5.77264 17.1398 6.02702 19.4194C6.02702 19.4194 6.17239 22.3488 6.18854 22.4904C6.42947 24.6581 9.38386 27.1116 11.0232 26.9282C12.9157 26.7166 14.9467 23.1738 14.7637 21.5332C14.7475 21.3917 14.2441 18.5014 14.2441 18.5014L14.2455 18.5027Z"
        fill="#F9C1AD"
      />
      <path
        d="M6.29219 19.9625C6.29219 19.9625 5.72958 19.6821 5.38367 20.2685C5.03775 20.8563 5.53441 22.8595 6.54927 22.7463C7.56413 22.6331 6.29085 19.9625 6.29085 19.9625H6.29219Z"
        fill="#F9C1AD"
      />
      <path
        d="M14.1378 19.0864C14.1378 19.0864 14.6251 18.6887 15.0921 19.1848C15.5578 19.6822 15.5147 21.7448 14.4985 21.858C13.4837 21.9713 14.1378 19.0864 14.1378 19.0864Z"
        fill="#F9C1AD"
      />
      <g clipPath="url(#clip0_4597_27940)">
        <path
          d="M19.9257 30.7541L5.69592 33.113L29.0668 45.5761L23.0822 32.4376C22.5304 31.2265 21.2373 30.5366 19.9261 30.754L19.9257 30.7541Z"
          fill="#CEA23E"
        />
      </g>
    </g>
    <mask
      id="mask1_4597_27940"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="23"
      y="0"
      width="29"
      height="30"
    >
      <circle
        cx="14.5"
        cy="14.5"
        r="14.5"
        transform="matrix(-1 0 0 1 52 0.5)"
        fill="#B94C24"
      />
    </mask>
    <g mask="url(#mask1_4597_27940)">
      <rect
        width="57.42"
        height="54.81"
        transform="matrix(-1 0 0 1 56.64 -5.00977)"
        fill="#D6D6D6"
      />
      <path
        d="M40.0396 9.625C41.9739 9.6436 44.3816 10.6682 44.0992 13.8436C43.9014 16.0687 43.3637 19.8764 41.8961 19.9948C41.2468 20.0472 39.0217 19.239 39.0217 19.239L38.8357 21.897L34.6611 20.7996L36.2995 17.3537C36.2995 17.3537 33.6652 9.56413 40.0396 9.62669V9.625Z"
        fill="#FFEACC"
      />
      <path
        d="M43.4432 10.9464L39.6422 14.2536C39.3954 13.2155 38.599 13.2628 38.0191 13.8969C37.3055 14.678 38.1746 15.7348 37.9937 16.0138C37.8111 16.2911 36.548 17.3799 36.3029 17.3512C36.056 17.3225 32.064 14.0676 35.5149 9.42465C37.106 7.28407 41.4531 7.53093 43.4449 10.9464H43.4432Z"
        fill="#323232"
      />
      <path
        d="M41.5461 6.14149C41.5022 7.66829 40.5215 8.59317 39.1316 8.55428C37.7435 8.51539 37.1381 7.49921 37.1804 5.9724C37.2244 4.4456 37.9886 3.31951 39.3785 3.3584C40.7683 3.39729 41.5901 4.61299 41.5461 6.13979V6.14149Z"
        fill="#323232"
      />
      <path
        d="M40.0109 20.5072L26.6855 17.2422C26.6855 17.2422 23.9785 25.6827 30.686 26.0767C37.3918 26.4724 40.0092 20.5072 40.0092 20.5072H40.0109Z"
        fill="#66AFFF"
      />
      <path
        d="M36.3722 20.0847C34.4548 20.203 32.5712 20.668 31.3352 24.2864C29.5734 29.2709 28.3273 37.9566 28.2816 54.4404L43.9217 48.5885C42.3103 40.1412 42.9681 23.2161 40.0108 20.5091C38.7816 19.9917 38.0004 19.9849 36.3722 20.0864V20.0847Z"
        fill="#66AFFF"
      />
    </g>
    <mask
      id="mask2_4597_27940"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="54"
      y="8"
      width="21"
      height="22"
    >
      <circle cx="64.5" cy="19" r="10.5" fill="#B94C24" />
    </mask>
    <g mask="url(#mask2_4597_27940)">
      <rect x="50.64" y="4.50977" width="41.58" height="39.69" fill="#A88DE2" />
      <path
        d="M67.2582 32.9566C73.4781 29.2963 68.8204 14.248 68.8204 14.248C68.8204 14.248 62.4634 12.6068 61.757 14.2812C59.1145 20.5465 54.0289 29.8613 55.7075 33.3097C56.7171 35.3829 65.4965 33.9994 67.2623 32.9607L67.2582 32.9566Z"
        fill="#282644"
      />
      <path
        d="M59.6879 25.594C59.6879 25.594 54.6314 29.0382 53.173 43.8705C52.155 54.2573 51.27 57.9134 51.27 57.9134L54.2491 57.955C54.2491 57.955 60.0743 43.401 60.602 36.9405C60.8513 33.8868 59.6879 25.5898 59.6879 25.5898V25.594Z"
        fill="#7B7B7B"
      />
      <path
        d="M70.5697 25.457C70.5697 25.457 76.4364 27.7504 77.7203 43.451C78.5721 53.8544 79.4446 57.9136 79.4446 57.9136L76.4655 57.9551C76.4655 57.9551 70.6403 43.4012 70.1126 36.9406C69.8633 33.8869 70.5697 25.457 70.5697 25.457Z"
        fill="#7B7B7B"
      />
      <path
        d="M63.5853 24.3521C61.6823 24.4685 59.5841 24.805 58.9982 26.791C58.6035 29.4998 59.8998 38.1624 58.2628 47.0285C55.9568 59.5092 56.4471 73.0245 56.4471 73.0245L74.6415 73.1616C74.6415 73.1616 74.8742 59.5092 73.0086 47.1656C71.7455 38.8063 72.7926 30.5593 71.6167 26.791C70.9977 24.805 68.0227 24.6097 67.0131 24.3563C65.7915 23.8411 65.2057 24.2566 63.5853 24.3563V24.3521Z"
        fill="#7B7B7B"
      />
      <path
        d="M61.6781 17.4592C61.6781 17.4592 61.2502 15.0827 62.0105 13.6161C62.9661 11.7715 65.8247 10.7536 68.0227 12.7187C69.5559 14.0856 68.7498 17.6961 68.7498 17.6961L63.955 15.6561L61.6823 17.4592H61.6781Z"
        fill="#282644"
      />
      <path
        d="M67.0089 24.3515C67.0089 24.3515 64.9979 25.4151 63.5811 24.3515L63.8844 20.6621H66.7098L67.0089 24.3515Z"
        fill="#D57D7B"
      />
      <path
        d="M62.2764 17.0396C62.2764 17.0396 61.8693 16.7779 61.5576 17.1975C61.2419 17.6171 61.4538 19.1835 62.239 19.1835C63.0243 19.1835 62.2764 17.0396 62.2764 17.0396Z"
        fill="#D57D7B"
      />
      <path
        d="M68.3385 17.0396C68.3385 17.0396 68.7457 16.7779 69.0573 17.1975C69.3731 17.6171 69.1612 19.1835 68.3801 19.1835C67.5989 19.1835 68.3385 17.0396 68.3385 17.0396Z"
        fill="#D57D7B"
      />
      <path
        d="M68.4714 16.6078C68.4714 14.8503 67.0505 13.6953 65.2971 13.6953C63.5437 13.6953 62.1227 14.8462 62.1227 16.6078C62.1227 16.6078 61.9856 18.8513 61.9856 18.9593C61.9856 20.6295 64.034 22.7526 65.2971 22.7526C66.7596 22.7526 68.6086 20.2265 68.6086 18.9593C68.6086 18.8513 68.4714 16.6078 68.4714 16.6078Z"
        fill="#E2847E"
      />
    </g>
    <defs>
      <clipPath id="clip0_4597_27940">
        <rect
          width="31.7837"
          height="31.8115"
          fill="white"
          transform="matrix(0.882375 0.470547 -0.469399 0.882986 9.03284 21.1934)"
        />
      </clipPath>
    </defs>
  </Icon>
);

export default memo(InvitePeopleIcon);
